import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { Tag } from '@/models/tag';
import { GEnum } from '@/constants/enum.defination';
import i18n from '@/i18n';
import { cookieService } from '@/service/cookie.service';
import { store } from '@/store';

export const DEFAULT_ICON_URL = 'https://s3-ap-northeast-1.amazonaws.com/grow-asset/user_icons/default.png';

export class Student implements Serializable<Student> {
  email: string;
  firstName: string;
  firstNameKana: string;
  potentialCompetencyID: number;
  highCompetencyID: number;
  iconURL: string;
  isSuspiciousStudent: boolean;
  lastName: string;
  lastNameKana: string;
  learningIncentive: string[];
  lowCompetencyID: number;
  reportURL: string = '';
  simpleReportURL: string = '';
  trendReportURL: string = '';
  schoolClass: SchoolClass;
  studentID: number;
  userID: number;
  studentNumber: string;
  manageNumber: number;
  tag: Tag[];
  selectedTagContents: string[];
  fullName: string;
  priorityTag: Tag;

  checked: boolean = false;
  selected: boolean = false; //UIの選択パラメーター用(受検者設定時の割り当て制御に使用)
  dragState: GEnum.DragState = GEnum.DragState.Fixed;

  deserialize(input: any): Student {
    this.email = input.email;
    this.firstName = input.firstName;
    this.firstNameKana = input.firstNameKana;
    this.potentialCompetencyID = input.growthPotentialCompetencyID;
    this.highCompetencyID = input.higherCompetencyID;
    this.iconURL = DEFAULT_ICON_URL;
    this.isSuspiciousStudent = input.isSuspiciousStudent;
    this.lastName = input.lastName;
    this.lastNameKana = input.lastNameKana;
    this.learningIncentive = input.learningIncentive;
    this.lowCompetencyID = input.lowerCompetencyID;
    if (input.priorityTag) {
      this.priorityTag = new Tag().deserialize(input.priorityTag);
    }

    if (input.reportURL !== null) {
      this.reportURL = input.reportURL;
    }
    if (input.simpleReportURL !== null) {
      this.simpleReportURL = input.simpleReportURL;
    }
    if (input.trendReportURL !== null) {
      this.trendReportURL = input.trendReportURL;
    }
    if (input.schoolClass) {
      this.schoolClass = new SchoolClass().deserialize(input.schoolClass);
    }
    this.studentID = input.studentID;
    this.userID = input.userID;
    this.studentNumber = input.studentNumber;

    if (input.manageNumber) {
      this.manageNumber = input.manageNumber;
    } else {
      this.manageNumber = null;
    }
    
    if (input.tag) {
      this.tag = input.tag.map((t: any) => new Tag().deserialize(t));
    }

    // 氏名の設定
    // 現在の言語設定により設定される
    // 言語切り替えにより、currentLang が変化 => currentLang に 名前の順（boolean）を保持している
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      this.fullName = `${input.lastName} ${input.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      this.fullName = `${input.firstName} ${input.lastName}`;
    }

    if (input.checked !== undefined) {
      this.checked = input.checked;
    }

    return this;
  }

  get stateColor(): string {
    switch (this.dragState) {
      case GEnum.DragState.Fixed:
        return 'bg-gray-3';
      case GEnum.DragState.Changed:
        return 'bg-green-2';
      case GEnum.DragState.Selected:
        return 'bg-orange-3';
      case GEnum.DragState.Checked:
        return 'bg-green-3';
    }
  }

  get gradeAndSchoolClassName(): string {
    if (this.schoolClass) {
      return i18n.t('NUMBER_YEAR', {value: this.schoolClass.grade}).toString() + ` ${this.schoolClass.schoolClassName}`;
    }
  }

  get tagContents(): string[] {
    return this.tag.map((tag: Tag) => tag.tagContent);
  }

  get feedbackReportUrl(): string {
    if (this.reportURL) {
      return this.reportURL + "&lang=" + cookieService.language;
    }
    return '';
  }

  get simpleFeedbackReportUrl(): string {
    if (this.simpleReportURL) {
      return this.simpleReportURL + "&lang=" + cookieService.language;
    }
    return '';
  }
}

export class StudentKartePrevNext implements Serializable<StudentKartePrevNext> {
  prev: StudentKartePrevNextData;
  next: StudentKartePrevNextData;
  deserialize(input: any): StudentKartePrevNext {
    if (input.prev) {
      this.prev = new StudentKartePrevNextData().deserialize(input.prev);
    }
    if (input.next) {
      this.next = new StudentKartePrevNextData().deserialize(input.next);
    }

    return this;
  }

  get hasPrevnext(): boolean {
    return this.prev != undefined || this.next != undefined;
  }
}

export class StudentKartePrevNextData implements Serializable<StudentKartePrevNextData> {
  firstName: string;
  lastName: string;
  studentID: number;

  deserialize(input: any): StudentKartePrevNextData {
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    this.studentID = input.studentID;

    return this;
  }

  getFullName(deli: string = " "): string {
    return this.lastName + deli + this.firstName;
  }
}